<template>
  <div class="desktop-beta">
    <desktop-beta-container>
      <desktop-beta-download />
    </desktop-beta-container>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import DesktopBetaContainer from "@/components/organisms/DesktopBetaContainer.vue";
import DesktopBetaDownload from "@/components/organisms/DesktopBetaDownload.vue";

export default Vue.extend({
  name: "DesktopBetaPage",
  metaInfo() {
    return {
      title: this.$t("app.meta.desktopBetaTitle") as string,
      titleTemplate: "%s",
      meta: [
        { name: "robots", content: "none" },
        {
          vmid: "description",
          name: "description",
          content: this.$t("app.meta.desktopBetaDescription") as string,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: this.$t("app.meta.desktopBetaTitle") as string,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.$t("app.meta.desktopBetaDescription") as string,
        },
        { vmid: "og:url", property: "og:url", content: window.location.href },
      ],
    };
  },
  components: {
    DesktopBetaContainer,
    DesktopBetaDownload,
  },
});
</script>

<style lang="scss" scoped>
.desktop-beta {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
</style>
